<style lang="scss" scoped>
.strage-page {
  // background: #fff;
  position: relative;
  // height: calc(100vh - 40px);
  // display: flex;
  // flex-direction: column;
}
.strage-good-wrapper {
  display: flex;
  // min-height: calc(100vh - 38px - 44px);
  position: relative;
  box-sizing: border-box;
  flex-direction: column;
  box-sizing: border-box;
  // min-height: calc(100vh - 38px - 44px - constant(safe-area-inset-bottom));
  // min-height: calc(100vh - 38px - 44px - env(safe-area-inset-bottom));
  &.has-class2 {
    // min-height: calc(100vh - 38px - 44px - 40px);
    // min-height: calc(
    //   100vh - 38px - 44px - 40px - constant(safe-area-inset-bottom)
    // );
    // min-height: calc(100vh - 38px - 44px - 40px - env(safe-area-inset-bottom));
  }
}
</style>

<template>
  <div ref="stragePageModule" class="strage-page">
    <feed-tab
      :class1-list="class1List"
      :class2-list="class2List"
      :class1-id="class1Id"
      :class2-id="class2Id"
      @onClass1Change="onClass1Change"
      @selectClass2="selectClass2"
    ></feed-tab>
    <div
      v-if="loaded"
      class="strage-good-wrapper"
      :class="class2List.length > 0 ? 'has-class2' : ''"
      :style="wrapperStyle"
    >
      <feed-list
        :list="feedList"
        :template-type="templateType"
        :good-width="computedGoodWidth"
        :good-style="goodStyle"
        :factor="factor"
        :is-loading="isLoading"
      ></feed-list>
      <bottom-loading
        v-if="feedList.length"
        :status="isLastPage ? 'isLastPage' : 'isLoading'"
      ></bottom-loading>
    </div>
  </div>
</template>
<script>
import { API } from '@/api'
import { miniProgramEnv } from '@/defines/environment'
import BottomLoading from './components/BottomLoading'
import FeedTab from './FeedTab'
import FeedList from './FeedList'

const clientHeight =
  document.documentElement.clientHeight || document.body.clientHeight
// 一页多少个商品
const PAGE_SIZE = 10
// 不够一屏，请求下一页面
const NEXT_PAGE_SIZE = 8

const enumGoodsLayoutType = {
  single: 'sole',
  double: 'double',
  triple: 'tris'
}

const factors = {
  [enumGoodsLayoutType.single]: 1,
  [enumGoodsLayoutType.double]: 2,
  [enumGoodsLayoutType.triple]: 3
}

export default {
  components: {
    FeedTab,
    FeedList,
    BottomLoading
  },
  props: {
    cmsPageId: {
      type: Number,
      default: 0
    },
    feedTabData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      currentTabIndex: 0, // 当前tab index
      feedList: [], // feed流推荐商品列表
      isLoading: false,
      isLastPage: false,
      // tab数据
      class1List: [],
      class2List: [],
      class1Id: '',
      class2Id: '',
      moduleKey: '',
      customSource: '',
      page: 1,
      reachBottomLoading: false,
      noMoreData: false,
      templateType: '',
      goodWidth: '',
      goodStyle: {},
      loaded: false,
      factor: 1,
      tickerInfo: {},
      containerStyle: {},
      moduleStyle: {}
    }
  },
  computed: {
    stickyTop() {
      if (miniProgramEnv.isMiniProgram) return '0px'
      return this.statusBarHeight + 44 + 'px'
    },
    barBottom() {
      return this.safeBottomMargin + 'px'
    },
    strageHeight() {
      const hasClass2 = this.class2List.length > 0
      //  min-height: calc(100vh - 38px - 44px);
      // min-height: calc(100vh - 38px - 44px - 40px);
      //  height: calc(66vh - 88px - constant(safe-area-inset-bottom));
      // height: calc(66vh - 88px - env(safe-area-inset-bottom));
      return {
        minHeight: hasClass2
          ? `calc(100vh - ${this.stickyTop} - constant(safe-area-inset-bottom) - 38px - 40px)`
          : `calc(100vh - ${this.stickyTop} - constant(safe-area-inset-bottom) - 38px)`,
        // eslint-disable-next-line no-dupe-keys
        minHeight: hasClass2
          ? `calc(100vh - ${this.stickyTop} - env(safe-area-inset-bottom) - 38px - 40px)`
          : `calc(100vh - ${this.stickyTop} - env(safe-area-inset-bottom) - 38px)`
      }
    },
    wrapperStyle() {
      return {
        ...this.containerStyle,
        ...this.strageHeight
      }
    }
  },
  created() {
    this.initData()
  },
  mounted() {
    window.addEventListener('scroll', this.pageScroll, {
      passive: true
    })
  },
  destroyed() {
    window.removeEventListener('scroll', this.pageScroll)
  },
  methods: {
    // 页面重置滚动
    handleScrollIntoView(id, type) {
      const repeatClick =
        (type === 'class1' && id === this.class1Id) ||
        (type === 'class2' && id === this.class2Id)
      if (repeatClick) return
      this.$refs.stragePageModule.scrollIntoView()
    },
    async pageScroll() {
      if (
        this.$refs.stragePageModule.getBoundingClientRect().bottom <=
        clientHeight + 40
      ) {
        if (!this.isLoading && !this.isLastPage) {
          this.isLoading = true
          await this.getMoreFeedList()
          this.isLoading = false
        }
      }
    },
    computedGoodWidth() {
      const ms = this.moduleStyle.ms
      const ps = this.moduleStyle.ps
      const elementMargin = this.moduleStyle.is || 0
      const realMs = ms ? this.valueCalc(ms, true) : 0
      const realPs = ps ? this.valueCalc(ps, true) : 0
      const factor = factors[this.templateType]
      const baseWidth = window.innerWidth * 2
      const scale = 2
      const realWidth = baseWidth / scale
      const realContentWidth = realWidth - realMs * 2 - realPs * 2

      const contentWidth = Math.floor(
        ((realContentWidth * 750) / baseWidth) * scale
      )

      const margins = elementMargin * (factor - 1)
      const computedWidth = (contentWidth - margins) / factor

      const goodWidth = Math.ceil((computedWidth * baseWidth) / 750 / scale)
      this.goodStyle = {
        width: goodWidth + 'px'
      }
      this.factor = factor
      this.computedGoodWidth = factor === 1 ? 80 : parseInt(goodWidth)
    },

    valueCalc(value = 0, returnNumber) {
      const baseWidth = 750
      const unit = 'px'
      const scale = 2

      return value
        ? returnNumber
          ? Math.ceil((value * baseWidth) / 750 / scale)
          : `${Math.ceil((value * baseWidth) / 750 / scale)}${unit}`
        : '0'
    },

    backgroundProcessor(bgImg, bgColorStart, bgColorEnd) {
      const bgImgUrl = bgImg?.img_url
      if (bgImgUrl) {
        const style = {
          backgroundImage: `url(${bgImgUrl})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: '100% 100%'
        }
        return bgColorStart
          ? Object.assign(style, {
              backgroundColor: bgColorStart
            })
          : style
      }
      // 开始结束颜色都有且不一样，渐变
      if (bgColorStart && bgColorEnd && bgColorStart !== bgColorEnd) {
        return {
          backgroundImage: `linear-gradient(${bgColorStart}, ${bgColorEnd})`
        }
      }
      if (bgColorStart || bgColorEnd) {
        return {
          backgroundColor: bgColorStart || bgColorEnd
        }
      }
      return {}
    },

    containerStyleProcessor({
      mb,
      ms,
      mt,
      pb,
      ps,
      pt,
      br,
      bgImg,
      bgColorStart,
      bgColorEnd,
      is
    }) {
      const style = {
        marginBottom: this.valueCalc(mb),
        marginLeft: this.valueCalc(ms),
        marginRight: this.valueCalc(ms),
        marginTop: this.valueCalc(mt),
        paddingBottom: this.valueCalc(pb),
        paddingLeft: this.valueCalc(ps),
        paddingRight: this.valueCalc(ps),
        paddingTop: this.valueCalc(pt),
        borderRadius: this.valueCalc(br)
      }
      Object.assign(
        style,
        this.backgroundProcessor(
          bgImg || '',
          bgColorStart || '',
          bgColorEnd || ''
        )
      )
      return style
    },
    async getMoreFeedList() {
      const feedList = await this.getSpuListOptimize()
      const goods = this.goodsProcessor(feedList)
      const list = [...this.feedList, ...goods]
      this.feedList = list
    },

    initData() {
      this.class1List = this.feedTabData?.data
      this.templateType = this.feedTabData?.type

      // 处理样式
      const style = this.feedTabData?.style
      this.moduleStyle = style
      const containerStyle = this.containerStyleProcessor(style)
      this.containerStyle = containerStyle

      const activeClass1 = this.class1List?.[0]

      this.class1Id = activeClass1?.class1Id
      this.moduleKey = activeClass1?.moduleKey
      this.customSource = activeClass1?.customSource

      this.class2List = this.class1List?.[0]?.subClass || []
      this.class2Id = this.class2List?.[0]?.class2Id
      const tickerInfo = activeClass1?.tickerInfo
      this.hanleTickerInfo(tickerInfo, this.class1Id, this.class2Id)

      this.getNewSkuList()
      // 计算商品宽度
      this.computedGoodWidth()
    },
    async getNewSkuList() {
      this.page = 1
      this.isLoading = true
      const feedList = await this.getSpuListOptimize()
      const goods = feedList?.length ? feedList : []
      this.feedList = this.goodsProcessor(goods)
      this.loaded = true
      this.isLoading = false
    },
    async getSpuListOptimize() {
      let resultData = await this.getSkuList()
      while (
        resultData &&
        !this.isLastPage &&
        resultData?.length < NEXT_PAGE_SIZE
      ) {
        const nextSkus = await this.getSkuList()
        // 如果无网状态下则返回 null，此时不在请求
        if (nextSkus === null) break
        resultData = [...resultData, ...nextSkus]
      }

      return resultData || []
    },

    async getSkuList() {
      const page = this.page++
      const size = PAGE_SIZE

      const serviceParams = {
        class1Id: this.class1Id,
        moduleKey: this.moduleKey,
        customSource: this.customSource,
        page,
        size
      }
      if (this.class2Id) {
        serviceParams.class2Id = this.class2Id
      }

      try {
        const data = await API.similygoods.getGoodsInfoLocation(serviceParams)
        const resData = data?.[0] || {}
        const list = resData?.rows || []

        this.isLastPage = resData?.isLastPage === 1
        if (!resData) {
          this.isLastPage = true
        }

        return list || []
      } catch (e) {
        this.$catch(e)
        this.isLastPage = true
        return []
      }
    },

    goodsProcessor(list) {
      const tickerInfo = this.tickerInfo
      return list.map((skuItem, skuIndex) => {
        const ssuItem = skuItem.ssuList[0]
        const ssu = Object.assign({}, skuItem, {
          ssuInfo: {
            ...ssuItem,
            tickerInfo: {
              ...tickerInfo,
              click: {
                spm: tickerInfo?.goods?.spm,
                spmJson: tickerInfo?.goods?.spmJson
              },
              data: {
                ...tickerInfo?.data,
                sku_id: ssuItem.sku_id,
                ssu_id: ssuItem.ssuId,
                price: ssuItem.priceSpm
              }
            }
          }
        })
        return {
          ssu
        }
      })
    },

    onClass1Change({ tab, index }) {
      this.class1Id = tab?.class1Id
      this.moduleKey = tab?.moduleKey
      this.customSource = tab?.customSource

      this.class2List = tab?.subClass || []

      this.class2Id = this.class2List?.[0]?.class2Id

      const tickerInfo = tab?.tickerInfo
      this.hanleTickerInfo(tickerInfo, this.class1Id, this.class2Id)

      this.getNewSkuList()
      this.handleScrollIntoView(tab?.class1Id, 'class1')

      this.tracerReportClick(tickerInfo, 'class1')
    },

    tracerReportClick(tickerInfo, type) {
      if (type === 'class1') {
        const clickSpm = tickerInfo.click.spm
        if (clickSpm) {
          this.$track(
            clickSpm,
            Object.assign({}, tickerInfo.data, clickSpm.spmJson)
          )
        }
      } else if (type === 'class2') {
        const clickSpm = tickerInfo.subclass.spm
        if (clickSpm) {
          this.$track(
            clickSpm,
            Object.assign({}, tickerInfo.data, clickSpm.spmJson, {
              str_sale_class1_id: this.class1Id,
              str_sale_class2_id: this.class2Id
            })
          )
        }
      }
    },

    hanleTickerInfo(tickerInfo, class1Id, class2Id) {
      this.tickerInfo = {
        ...tickerInfo,
        data: {
          ...tickerInfo?.data,
          str_sale_class1_id: class1Id + '',
          str_sale_class2_id: class2Id + ''
        }
      }
    },

    async selectClass2(class2Item) {
      this.class2Id = class2Item?.class2Id

      const tickerInfo = this?.tickerInfo
      this.hanleTickerInfo(tickerInfo, this.class1Id, this.class2Id)
      const class2TickerInfo = class2Item?.tickerInfo
      this.tracerReportClick(class2TickerInfo, 'class2')

      this.getNewSkuList()
      this.handleScrollIntoView(class2Item?.class2Id, 'class2')
    }
  }
}
</script>
